import { useTranslation } from 'react-i18next'
import { RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import { useSwUpdate } from '@/lib/use-sw-update'

export function PWAUpdatePrompt() {
  const { t } = useTranslation()
  const { updateAvailable, applyUpdate } = useSwUpdate()

  if (!updateAvailable) {
    return null
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 p-4 pt-[calc(env(safe-area-inset-top)+0.5rem)] pointer-events-none">
      <Card className="max-w-md mx-auto p-4 pointer-events-auto shadow-lg">
        <div className="space-y-3">
          <h3 className="font-semibold">{t('pwa.updatePrompt.title')}</h3>
          <p className="text-sm text-muted-foreground">
            {t('pwa.updatePrompt.description')}
          </p>
          <Button onClick={applyUpdate} className="w-full" size="sm">
            <RefreshCw className="h-4 w-4 me-2" />
            {t('pwa.updatePrompt.update')}
          </Button>
        </div>
      </Card>
    </div>
  )
}
